<template>
    <div class="footer">
        <div class="footer__top">
            <div class="footer__top__left">
                <div class="footer__top__label">{{ $t('footer.owner') }}</div>
                <div class="footer__top__title">{{ footerData.owner.name }}</div>
                <MailTo class="footer__top__email" :email="footerData.owner.email"/>
                <div class="footer__top__left__address">{{ footerData.owner.address }}</div>
                <a class="footer__top__left__phone" :href="formatPhoneNumber(footerData.owner.phone)">{{ footerData.owner.phoneLabel }}</a>
            </div>
            <div class="footer__top__right">
                <div class="footer__top__label">{{ $t('footer.support') }}</div>
                <div class="footer__top__title">{{ footerData.support.name }}</div>
                <MailTo class="footer__top__email" :email="footerData.support.email"/>
                <div class="footer__top__left__address">{{ footerData.support.address }}</div>
                <a class="footer__top__left__phone" :href="formatPhoneNumber(footerData.support.phone)">{{ footerData.support.phoneLabel }}</a>
            </div>
        </div>
        <div class="footer__bottom">
            <div class="footer__bottom__left">
                <div>© {{getCurrentLocalYear}} Semmelweis Egyetem - {{ $t('labels.allRightsReserved') }}</div>
            </div>
            <div class="footer__bottom__right">
                <div class="footer__bottom__right_wrapper">
                    <a href="https://semmelweis.hu/adatvedelem" target="_blank">{{ $t('footer.dataProtection') }}</a>
                </div>
                <div class="footer__bottom__right_wrapper">
                    <a href="https://semmelweis.hu/cookie-tajekoztato" target="_blank">{{ $t('footer.cookieNotification') }}</a>
                </div>
                <div class="footer__bottom__right_wrapper">
                    <a href="https://semmelweis.hu/informatika/" target="_blank">{{ $t('footer.departmentWebpage') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MailTo from "./MailTo.vue";
export default {
    components: {MailTo},

    methods: {
        formatPhoneNumber(value) {
            return 'tel:' + (value.match(new RegExp('[+0-9wp,;]+', 'g'))?.join(''));
        },
    },

    computed: {
        getCurrentLocalYear() {
            return (new Date()).getFullYear();
        },

        footerData() {
            return window.frontendConfiguration.vueJs.footer;
        }
    }
}
</script>

<style lang="scss">
@use "../../scss/mixins";

.footer {
    background-color: var(--footer-background-color);
    color: var(--footer-font-color);
    font-size: 0.8em;

    &__top,
    &__bottom {
        padding: var(--padding-thin);

        &__label {
            margin-bottom: var(--margin);
            text-decoration: underline;
            font-weight: bold;
        }

        & > *:not(:last-child) {
            margin-bottom: var(--margin);
        }

        @include mixins.breakpoint-md {
            & > *:not(:last-child) {
                margin-bottom: unset;
            }
        }
    }

    &__top {
        @include mixins.breakpoint-md {
            display: grid;
            gap: var(--gap-thin);
            grid-template-columns: 1fr 1fr;
            padding: var(--padding);
        }
    }

    &__bottom {
        background-color: var(--footer-bottom-background-color);
        color: var(--footer-bottom-font-color);

        &__right {
            & > *:not(:last-child) {
                margin-bottom: var(--margin-thin);
            }
        }

        @include mixins.breakpoint-md {
            display: grid;
            gap: var(--gap-thin);
            grid-template-columns: 1fr auto;

            &__right {
                display: flex;
                gap: var(--gap-thin);
                align-items: center;

                &_wrapper {
                    &:not(:last-child) {
                        margin-bottom: unset;
                        display: grid;

                        & *:after {
                            display: inline;
                            content: '';
                            margin-left: var(--gap-thin);
                            border-right: 2px solid var(--footer-bottom-font-color);
                        }
                    }
                }
            }
        }
    }
}
</style>
